
import {
    Typography,
    Divider,
}from '@mui/material';

import css from '../../../../styles/landing/pages/login.module.css';

const Home = () => {
    return(
        <div className={css.container}>
                <Typography variant="h5" component="div" sx={{ textAlign: 'center', p: 3 }}>
                    Home
                </Typography>
                <Divider />
                <Typography variant="subtitle2" component="div" sx={{ textAlign: 'center', p: 2 }}>
                    Welcome to the Back Office
                </Typography>
        </div>
    );

};

export default Home;